import axios from "axios";
import { Cookies } from "react-cookie";
import { proxy } from "../config";
const cookie = new Cookies();

export const getPrimaryProjects = async (page, projectType) => {
  const token = await cookie.get("token");
  return await axios.get(
    `${proxy}/new_projects/all_projects?page=${page}&&projectType=${projectType}&&areaName=All`,
    {
      headers: { Authorization: token },
    },
  );
};

export const searchPrimaryProjects = async (page, projectType, search) => {
  const token = await cookie.get("token");
  return await axios.get(
    `${proxy}/new_projects/search_projects?page=${page}&&projectType=${projectType}&&areaName=All&&search=${search}`,
    {
      headers: { Authorization: token },
    },
  );
};

export const getProject = async (id) => {
  const token = await cookie.get("token");
  return await axios.get(`${proxy}/new_projects/id?id=${id}`, {
    headers: { Authorization: token },
  });
};

export const getParents = async () => {
  const token = await cookie.get("token");
  return await axios.get(`${proxy}/new_projects/parent`, {
    headers: { Authorization: token },
  });
};

export const getProperties = async (id, fromId) => {
  const token = await cookie.get("token");
  return await axios.get(
    `${proxy}/new_projects/properties?id=${id}&&fromId=${fromId}`,
    {
      headers: { Authorization: token },
    },
  );
};

export const getProperty = async (id) => {
  const token = await cookie.get("token");
  return await axios.get(`${proxy}/new_projects/property?id=${id}`, {
    headers: { Authorization: token },
  });
};

export const getFinishAndTypes = async () => {
  const token = await cookie.get("token");
  return await axios.get(`${proxy}/new_projects/finishing_and_types`, {
    headers: { Authorization: token },
  });
};

export const createPrimary = async (formData) => {
  const token = await cookie.get("token");
  return await axios.post(`${proxy}/new_projects/create_primary`, formData, {
    headers: { Authorization: token },
  });
};

export const updatePrimary = async (id, formData) => {
  const token = await cookie.get("token");
  return await axios.put(`${proxy}/new_projects/update_primary?id=${id}`, formData, {
    headers: { Authorization: token },
  });
};

export const createProperty = async (formData) => {
  const token = await cookie.get("token");
  return await axios.post(`${proxy}/new_projects/create_property`, formData, {
    headers: { Authorization: token },
  });
};

export const deleteProperty = async (id) => {
  const token = await cookie.get("token");
  return await axios.delete(`${proxy}/new_projects/delete_property?id=${id}`, {
    headers: { Authorization: token },
  });
};

export const updateProperty = async (id, formData) => {
  const token = await cookie.get("token");
  return await axios.put(
    `${proxy}/new_projects/update_property?id=${id}`,
    formData,
    {
      headers: { Authorization: token },
    },
  );
};

export const createPhase = async (formData) => {
  const token = await cookie.get("token");
  return await axios.post(`${proxy}/new_projects/add_phase`, formData, {
    headers: { Authorization: token },
  });
};

export const deletePhase = async (formData) => {
  const token = await cookie.get("token");
  return await axios.post(`${proxy}/new_projects/delete_phase`, formData, {
    headers: { Authorization: token },
  });
};

export const getExcel = async () => {
  const res = await fetch(`${proxy}/new_projects/excel`);
  const blob = await res.blob();

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "Primary.xlsx";
  a.click();
  window.URL.revokeObjectURL(url);
};

export const uploadExcel = async (excel) => {
  const token = await cookie.get("token");
  return await axios.put(`${proxy}/new_projects/read`, excel, {
    headers: { Authorization: token },
  });
};

export const deletePrimary = async (id) => {
  const token = await cookie.get("token");
  return await axios.delete(`${proxy}/new_projects/delete?id=${id}`, {
    headers: { Authorization: token },
  });
};